import {GetPaginationBedDto} from '../../../hoteleria/features/bed/model'
import {getBedsService} from '../../../hoteleria/features/bed/services'
import {GetModuleFilter} from '../../../hoteleria/features/modules/models'
import {getModulesService} from '../../../hoteleria/features/modules/services'
import {GetRoomFilter} from '../../../hoteleria/features/room/models'
import {getRoomsService} from '../../../hoteleria/services/room.service'

export const useHoteleriaServices = () => {
  const getModules = async (filters: GetModuleFilter) => {
    try {
      const response = await getModulesService(filters)
      const data = response.data.data
      return data
    } catch (error) {
      console.log('getModules error', error)
      return []
    }
  }

  const getRooms = async (filters: GetRoomFilter) => {
    try {
      const response = await getRoomsService(filters)
      const data = response.data.data
      return data
    } catch (error) {
      console.log('getRooms error', error)
      return []
    }
  }

  const getBeds = async (filters: GetPaginationBedDto) => {
    const response = await getBedsService(filters)
    const data = response.data.data
    return data
  }

  return {
    getModules,
    getRooms,
    getBeds,
  }
}
